import React from 'react';

export const GridContainer = ({ children, ...rest }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className='grid grid-cols-1 xl:grid-cols-2 sm:gap-10 gap-8' {...rest}>
      {children}
    </div>
  );
};
